"use client"
import "aos/dist/aos.css"
import Title from "../Title/Title"

function Alliance() {
  return (
    <article
      className="px-5 xl:px-16 3xl:px-24 py-16 bg-white"
      data-aos="fade-up"
      data-aos-duration="1000"
      data-aos-delay="400"
    >
      <div className="flex flex-col xl:flex-row justify-between w-full pb-16 border-b border-b-[--color-gray]">
        <div className="flex xl:w-2/3">
          <Title
            type="h2"
            className="uppercase text-[24px] xl:text-[60px]"
            title="Alliances"
          />
        </div>
        <div className="flex xl:w-1/3 items-center gap-2 pe-[24px]">
          <p className="2 ">
            Cyber stone&apos;s global alliances initiative combines our thought
            leadership with the strengths of our partners to enhance and expand
            the business and technology offerings available to our clients.
            Learn more about our entire partner portfolio.
          </p>
        </div>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-12 mt-16 justify-around items-center">
        {/* Render alliance images a-1.png to a-18.png */}
        {Array.from({ length: 18 }, (_, i) => (
          <img
            key={i}
            src={`/alliance/a-${i + 1}.png`}
            width={200}
            height={52}
            alt={`Alliance partner logo ${i + 1}`}
            loading="lazy"
            decoding="async"
          />
        ))}
      </div>
    </article>
  )
}

export default Alliance
